import { DeckDef } from "./types";
import { whyDeck } from "./decks/whyDeck";
import { municipalitiesDeck } from "./decks/municipalitiesDeck";
import { howItWorksDeck, organizationsDeck, securityDeck, sovereigntyDeck } from "./decks/otherDecks";
import { extendedDeck } from "./decks/extendedDeck";

export * from "./types";
export * from "./PresentationModel";
export * from "./decks/whyDeck";
export * from "./decks/municipalitiesDeck";
export * from "./decks/otherDecks";
export * from "./decks/extendedDeck";

// Rejestr wszystkich prezentacji (kolejność = kolejność w widoku wyboru).
export const DECKS: DeckDef[] = [
  extendedDeck,
  whyDeck,
  howItWorksDeck,
  municipalitiesDeck,
  securityDeck,
  sovereigntyDeck,
  organizationsDeck
];

export const getDeck = (slug?: string): DeckDef | undefined => DECKS.find((d) => d.slug === slug);
